import { useContext, useEffect, useRef } from "react";
import styles from "./content.module.css";
import { Context } from "../../../global/store";
const Content = () => {
  const [state, dispatch] = useContext(Context);
  const sectionsRefs = useRef([]);

  useEffect(() => {
    const setPositions = (refs) => {
      refs.forEach((item, index) => {
        const pos = item.offsetTop;
        dispatch({
          type: "SET_SINGLE_POSITION",
          payload: { id: index, pos: pos },
        });
        // console.log(pos);
      });
    };
    console.log("useEffect");
    if (sectionsRefs.current !== undefined) {
      // console.log(sectionsRefs.current[0].offsetTop);
      setPositions(sectionsRefs.current);
    }
  } , [dispatch]);

  const sectionsList = state.sections.map((section) => {
    if (section.id !== 99) {
      return (
        <section
          key={section.id}
          className={styles.section}
          id={section.sid}
          ref={(el) => (sectionsRefs.current[section.id] = el)}
        >
          <div className={styles.title}>{section.title}</div>
          <div className={styles.inner}>{section.content}</div>
        </section>
      );
    }else{
      return(null);
    }
  });

  return (
    <div className={`${styles.box} w-full lg:w-3/4`}>
      <div className={styles.content}>
        {/* Start Sections */}
        {sectionsList}
        {/* End Sections */}
      </div>
    </div>
  );
};

export default Content;
